import { Table } from '@/components/product_multiplier_type/table'
import { ProductMultiplierProductType } from '@/types'
interface Props {
  id: string
}

export const EditMultipliers = ({ id }: Props) => {
  return (
    <Table filters={ { productIdEq: id, productTypeEq: ProductMultiplierProductType.Package } } createable deleteable />
  )
}
